import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import { unregister } from './registerServiceWorker';
import Footer from './components/Misc/AppFooter'
import 'babel-polyfill';
import { I18nextProvider } from "react-i18next";
import i18n from "./server/i18n";
/* ReactDOM.render(
    <App />
   , document.getElementById('root'));
ReactDOM.render(
    <Footer/>, document.getElementById('footer')); */
    ReactDOM.render(<I18nextProvider i18n={i18n}>
        <App /></I18nextProvider>
       , document.getElementById('root'));
   
// The old service worker cached index.html and served stale bundle hashes after deploys.
unregister();



// WEBPACK FOOTER //
// ./src/index.js